import React, { useEffect, useState } from "react";
import { Maximize2, Minimize2, PanelLeftClose, PanelLeftOpen, SatelliteDish, Send } from "lucide-react";
import { StormDeskRadar } from "../components/StormDeskRadar";
import { toast } from "../components/ui/sonner";
import { useStudioAuth } from "../operations/StudioAuthContext";
import { OpsPage, StatusChip } from "../operations/ui";

const OperationsRadar = () => {
  const { request } = useStudioAuth();
  const [focusMode, setFocusMode] = useState(false);
  const [panelCollapsed, setPanelCollapsed] = useState(false);
  const [relay, setRelay] = useState(null);

  useEffect(() => {
    request("/operations/relay").then(async (response) => {
      if (response.ok) setRelay(await response.json());
    });
  }, [request]);

  const sendToStudio = async () => {
    const response = await request("/broadcast", { method: "POST", body: JSON.stringify({ preview_scene: "radar_full" }) });
    if (response.ok) toast.success("Storm Desk Radar staged in Preview");
    else toast.error("Could not update Preview");
  };

  if (focusMode) {
    return (
      <div className="fixed inset-0 z-[100] bg-[#01020a] p-2">
        <button data-testid="radar-exit-focus-mode-button" onClick={() => setFocusMode(false)} className="mono absolute right-4 top-4 z-[120] flex items-center gap-2 border border-white/20 bg-black/85 px-3 py-2 text-[10px] font-bold uppercase tracking-widest text-white shadow-xl hover:bg-black">
          <Minimize2 className="h-4 w-4" /> Exit focus
        </button>
        <StormDeskRadar height="calc(100vh - 16px)" hideHeader initialPanelCollapsed relayRunning={Boolean(relay?.running)} />
      </div>
    );
  }

  const iconButton = "grid h-8 w-8 place-items-center border border-white/10 text-slate-400 transition-colors hover:bg-white/5 hover:text-white";

  return (
    <OpsPage
      icon={SatelliteDish}
      title="Radar"
      eyebrow="Live interactive weather intelligence"
      actions={
        <>
          <StatusChip state={relay?.running ? "live" : "idle"}>{relay?.running ? "On air" : "Standby"}</StatusChip>
          <button data-testid="radar-toggle-alert-panel-button" onClick={() => setPanelCollapsed((value) => !value)} title={panelCollapsed ? "Show alerts" : "Hide alerts"} className={iconButton}>
            {panelCollapsed ? <PanelLeftOpen className="h-4 w-4" /> : <PanelLeftClose className="h-4 w-4" />}
          </button>
          <button data-testid="radar-focus-mode-button" onClick={() => setFocusMode(true)} title="Focus mode" className={iconButton}>
            <Maximize2 className="h-4 w-4" />
          </button>
          <button data-testid="send-radar-to-studio-button" onClick={sendToStudio} className="mono flex h-8 items-center gap-2 bg-[#1a5cff] px-3 text-[10px] font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#2a6cff]">
            <Send className="h-3.5 w-3.5" /> Send to Preview
          </button>
        </>
      }
    >
      <StormDeskRadar
        height="max(560px, calc(100vh - 190px))"
        hideHeader
        initialPanelCollapsed={panelCollapsed}
        relayRunning={Boolean(relay?.running)}
      />
    </OpsPage>
  );
};

export default OperationsRadar;
